import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RdsSelectableDirective } from './selectable';

@NgModule({
  imports: [CommonModule],
  declarations: [RdsSelectableDirective],
  exports: [RdsSelectableDirective],
})
export class RdsSelectableModule {}

export * from './selectable';
